import React, { Component } from "react";
import { Header, Footer } from "./../../../../../../components";
import { Cover, TextHeader } from "./components";
import styled from "styled-components";
import { Row, Col, Button, Table } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";
import "./style.css";

//ContactContainer
import bgContact from "../../../../../../assets/images/career/1366x455/Developer.jpg";

import color from "../../../../../../config/color";
import "./style.css";

import { withNamespaces } from "react-i18next";

AOS.init({
    delay: 100
});

const Container = styled.div``;


const ContactContainer = styled.div`
background:
        /* top, transparent black, faked with gradient */ 
        linear-gradient(
          rgba(0, 0, 0, 0.4), 
          rgba(0, 0, 0, 0.4)
        ),
        /* bottom, image */
        url(${bgContact});
        text-shadow: 0px 3px 6px #000;
  /* background-image: url(${bgContact}); */
  height: 455px;
  padding: 50px 0;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;

  .container {
    text-align: center;
    color: #fff;
    padding: 120px;
    position: relative;
    height: 140px;

    .check-button {
      height: 40px;
      width: 140px;
      font-size: 24px;
    }
  }

  @media only screen and (max-width: 767px) {
    .container {
      text-align: center;
      color: #fff;
      padding:50px;
      position: relative;
      height: 140px;
      margin-top:50px;
    }
  }
`;

const DeviceContainer = styled.div`
  position: relative;
  margin-top: 30px;

  & .device-content {
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    border-radius: 6px;
    border: 1px solid #fafafafa;
    padding: 40px;

    & .download-container {
      display: flex;
      flex-direction: row;
      margin-top: 16px;
    }

    & .download-image-grcode {
      & img {
        width: 120px;
      }
    }

    & .download-line-vertical {
      width: 1px;
      background-color: #e3e3e3;
      margin: 0 20px;
    }

    & .download-image-store-container {
      display: flex;
      flex-direction: column;

      & img {
        width: 100%;
        max-width: 175px;
        margin-bottom: 10px;
      }
    }
  }

  & .device-image {
    margin-top: 50px;
    width: 260%;
    position: absolute;
    right: 0;

    & img {
      width: 100%;
    }
  }

  & .text-download {
    margin-top: 20px;
  }

  @media (max-width: 992px) {
    .device-image {
      margin-top: 100px;
      width: 220%;
    }
  }
`;


const StepCheckPriceContainer = styled.div`
	text-align: center;

	.check-button {
		height: 36px;
		width: 140px;
		font-size: 22px;
		font-weight: bold;
		border-radius: 6px;
		margin-top: 20px;
		box-shadow: 0px 6px 16px #d9010120;
		background-color: #fff;
		color: #d90101;

		& i {
			font-size: 20px;
		}

		&:hover {
			color: #fff;
			background-color: #d90101;
			box-shadow: 0px 10px 20px #d9010140;
		}
	}

	@media (min-width: 992px) {
		.cover-right {    
			padding-top: 150px;
		}

		.img-cover {    
			position: absolute;
			width: 200%;
			right: 0;
		}

		.title-header {
			font-size: 60px;
		}

		.title-sub-header {
			font-size: 30px;    
			font-weight: normal;
		}

		.check-button {
			height: 36px;
			width: 140px;
			font-size: 22px;

			& i {
				font-size: 20px;
			}
		}
	}

	@media (min-width: 1200px) {
		.img-cover {    
			position: absolute;
			width: 200%;
			right: 0;
		}

		.cover-right {    
			padding-top: 150px;
		}
		
		.title-header {
			font-size: 60px;
		}

		.title-sub-header {
			font-size: 30px;    
			font-weight: normal;
		}

		.check-button {
			height: 36px;
			width: 140px;
			font-size: 22px;

			& i {
				font-size: 26px;
			}
		}
	}

	@media (max-width: 992px) {
		padding-top: calc(45vh - 200px);
		.cover-right {
			padding-top: 200px;
		}
	}

	& .box-container {
		height: 310px;
		display: flex;
		align-items: center;
	}

	& .box {
		flex: 1;
		box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
		border: 1px solid #eeeeee50;
		padding: 35px 20px;
		background-color: #ffffff;
    box-sizing: border-box;
		border-radius: 5px;
		height: 280px;
		vertical-align: middle;

		display: flex;
		flex-direction: column;
		justify-content: center;
		transition: all .3s;

    &:hover {
			height: 310px;
      background-image: linear-gradient(to bottom right, ${
    color.Primary
    }, #9D0000);
			box-shadow: 0px 5px 10px rgba(217, 1, 1, 0.2);
			color: #FFFFFF;
			line-height: 1;

			& .box-title-subtitle {
				display: block;
			}

			& .box-image {
				display: none;

				&-hover {
					display: block;
				}
			}
    }

		&:not(:last-child) {
			margin-right: 20px;
		}

		& .box-image {
			display: block;

			& img {
				width: 120px;
				height: 120px;
			}
      & i {
        font-size: 80px;
      }

			&-hover {
				display: none;

				& img {
					width: 120px;
					height: 120px;
				}
      & i {
        font-size: 100px;
      }
			}
		}

		& .box-title {
			margin-top: 30px;
			font-weight: 700;
			text-align: center;
			font-size: 26px;
			line-height: 1;

			&-subtitle {
				display: none;
				margin-top: 5px;
				font-size: 20px;
				line-height: 1;
			}
		}
	}
`;


const TablePosition = styled(Table)`
  width: 100%;
  font-size: 24px;

  & tr {
    & td {
    border: none !important;
    }
   }

   & .title {
      border-left: 4px solid #D90101;
      border-radius: 2px;
    }
     .styleTitle {
      margin-left: 10px;
      font-weight: bold;
      font-size: 30px;
      text-align: left;
    }
    ul {
      list-style: none;
    }
    ul li {
      position: relative;
    }
    ul li::before {
      content: "• ";
      color: #D90101;
      width: 2em;
      position: absolute;
      left: -20px;
    }
`;

class GiztixBusiness extends Component {
    state = {
        isTop: true,
        onOpenModal: false
    };

    componentDidMount() {
        document.addEventListener("scroll", () => {
            const isTop = window.scrollY < 100;
            if (isTop !== this.state.isTop) {
                this.setState({ isTop });
            }
        });
    }

    render() {
        return (
            <Container>
                <Helmet>
                    <title>
                        Developer | GIZTIX บริการขนส่ง บริษัทขนส่ง รถรับจ้าง รถส่งของ
                          รถ6ล้อรับจ้าง รถกระบะรับจ้าง รถส่งสินค้า ส่งสินค้าด่วน
          </title>
                    <meta
                        name="description"
                        content="บริการรถขนส่งสินค้าที่ทั้งง่ายและปลอดภัย เช็คค่าบริการขนส่งได้ทันที จองออนไลน์ได้ทุกที่ ทุกเวลา"
                    />
                </Helmet>
                <Header
                    bgcolor={this.state.isTop ? "transparent" : "#000000"}
                    border={false}
                    color="white"
                />

                <ContactContainer>
                    <div className="container">
                        <TextHeader
                            className="title"
                            style={{ textAlign: "center" }}
                            styleTitle={{
                                marginBottom: 10,
                                textAlign: "center",
                                fontSize: 60,
                                fontWeight: "bold",
                                color: "#fff"
                            }}
                            title="Developer"
                        />
                        <p style={{ textAlign: "center" }}>
                            แท็กทีมเพื่อสร้างนวัตกรรมใหม่ๆ พัฒนาโปรแกรม และแอปพลิเคชั่นให้ใช้งานได้จริง
          </p>

                    </div>
                </ContactContainer>


                <div className="container" style={{ marginTop: -70 }}>

                    <TextHeader
                        styleTitle={{ marginBottom: 40, marginTop: 120, fontSize: 30 }}
                        title="ตำแหน่งงาน"
                    />

                    <TablePosition>
                        <tbody>
                            {/* Front-end Developer */}
                            <tr>
                                <Col md={4} sm={6}>
                                    <td>
                                        <div className="title">
                                            <label className="styleTitle">Front-end Developer</label>
                                        </div>
                                    </td>
                                </Col>
                                <Col md={8} sm={6}>
                                    <td>
                                        <ul>
                                            <li>
                                                ดูแลและพัฒนาเว็บไซด์ของบริษัทตาม Requirement และพัฒนา Web Applications
                        </li>
                                            <li>
                                                วิเคราะห์และออกแบบระบบ พร้อมจัดทำเอกสารที่เกี่ยวข้อง
                        </li>
                                            <li>
                                                แก้ไขปัญหาใน Application ที่มีอยู่หรือได้รับมอบหมาย
                        </li>
                                        </ul>
                                    </td>
                                </Col>
                            </tr>
                            <br />
                            <tr>
                                <Col md={4} sm={6}>
                                    <td>
                                        <label className="styleTitle" style={{ marginLeft: 20 }}>คุณสมบัติ</label>
                                    </td>
                                </Col>
                                <Col md={8} sm={6}>
                                    <td>
                                        <ul>
                                            <li>
                                                จบการศึกษา สาขาวิชาที่เกี่ยวข้อง
                        </li>
                                            <li>
                                                สามารถใช้ JavaScript รวมถึง ES6 (ES 2015) ได้เป็นอย่างดี
                        </li>
                                            <li>
                                                สามารถเขียน SPA (Single Page Application) ด้วย React, React Native
                        </li>
                                            <li>
                                                เข้าใจหลักการทำงานที่สำคัญของ React อย่างเช่น Concept, State Management,
                        <br />Lifecycle , หรือ Pros & Cons เป็นต้น
                        </li>
                                            <li>
                                                มีความเข้าใจและคุ้นเคย Web Service, RESTFul API
                        </li>
                                            <li>
                                                เข้าใจและสามารถเขียน HTML/CSS ได้
                        </li>
                                            <li>
                                                สามารถใช้ Git ที่เป็น Version Control ในการทำงานร่วมกับคนอื่นๆในทีม
                        </li>
                                            <li>
                                                สามารถเรียนรู้เทคโนโลยีใหม่ได้อย่างรวดเร็ว กล้าแสดงความคิดเห็น
                        <br />และสามารถเรียนรู้ได้ด้วยตนเอง
                        </li>
                                            <li>
                                                มีความรับผิดชอบต่องานที่ได้รับมอบหมายและสามารถติดตามงานของตัวเอง
                        <br />ให้เสร็จลุล่วงตามกำหนดได้
                        </li>
                                            <li>
                                                หากมีผลงานหรือตัวอย่างโปรเจคมาแสดงจะได้รับการพิจารณาเป็นพิเศษ
                        </li>
                                        </ul>
                                    </td>
                                </Col>
                            </tr>

                            <StepCheckPriceContainer>
                                <Button style={{ marginBottom: 20 }} bsStyle="primary" className="check-button" onClick={() => window.location = `https://docs.google.com/forms/d/e/1FAIpQLSewVoQ8Gg6-aHN-y_GGPhOr3v0W6VO-z0rQuf6mMInoj142Lw/viewform`}>
                                    สมัครงาน
                </Button>
                                <hr />
                            </StepCheckPriceContainer>
                            <br />

                            {/* Back-end Developer */}

                            <tr>
                                <Col md={4} sm={6}>
                                    <td>
                                        <div className="title">
                                            <label className="styleTitle">Back-end Developer</label>
                                        </div>
                                    </td>
                                </Col>
                                <Col md={8} sm={6}>
                                    <td>
                                        <ul>
                                            <li>
                                                พัฒนาและดูแลระบบ Backend ของผลิตภัณฑ์ของบริษัท
                        </li>
                                            <li>
                                                ออกแบบและใช้งานแอพพลิเคชั่น
                        </li>
                                            <li>
                                                Query in RDBMS, การกำหนดค่าเพื่อตอบสนอง
                        </li>
                                            <li>
                                                ควบคุมคุณภาพของโค้ดให้มีคุณภาพที่ดี ทำงานได้ถูกต้อง
                        </li>
                                            <li>
                                                ทดสอบและดูแลได้ง่าย มีความยืดหยุ่นพร้อมรับการเปลี่ยนแปลงในอนาคตได้ดี
                        </li>
                                        </ul>
                                    </td>
                                </Col>
                            </tr>
                            <br />
                            <tr>
                                <Col md={4} sm={6}>
                                    <td>
                                        <label className="styleTitle" style={{ marginLeft: 20 }}>คุณสมบัติ</label>
                                    </td>
                                </Col>
                                <Col md={8} sm={6}>
                                    <td>
                                        <ul>
                                            <li>
                                                จบการศึกษา สาขาวิชาที่เกี่ยวข้อง
                        </li>
                                            <li>
                                                สามารถใช้ JavaScript รวมถึง ES6 (ES 2015) ได้เป็นอย่างดี
                        </li>
                                            <li>
                                                เข้าใจหลักการทำงานที่สำคัญของ Node.js
                        </li>
                                            <li>
                                                มีความเข้าใจและคุ้นเคย Web Service, RESTFul API
                        </li>
                                            <li>
                                                สามารถใช้ Git ที่เป็น Version Control ในการทำงานร่วมกับคนอื่นๆในทีม
                        </li>
                                            <li>
                                                สามารถเรียนรู้เทคโนโลยีใหม่ได้อย่างรวดเร็ว กล้าแสดงความคิดเห็น
                        <br />และสามารถเรียนรู้ได้ด้วยตนเอง
                        </li>
                                            <li>
                                                มีความรับผิดชอบต่องานที่ได้รับมอบหมายและสามารถติดตามงานของตัวเอง
                        <br />ให้เสร็จลุล่วงตามกำหนดได้
                        </li>
                                            <li>
                                                หากมีผลงานหรือตัวอย่างโปรเจคมาแสดงจะได้รับการพิจารณาเป็นพิเศษ
                        </li>
                                        </ul>
                                    </td>
                                </Col>
                            </tr>
                            <StepCheckPriceContainer>
                                <Button style={{ marginBottom: 20 }} bsStyle="primary" className="check-button" onClick={() => window.location = `https://docs.google.com/forms/d/e/1FAIpQLSewVoQ8Gg6-aHN-y_GGPhOr3v0W6VO-z0rQuf6mMInoj142Lw/viewform`}>
                                    สมัครงาน
                </Button>
                                <hr />
                            </StepCheckPriceContainer>

                            <br />

                            {/* Mobile App Developer */}

                            <tr>
                                <Col md={4} sm={6}>
                                    <td>
                                        <div className="title">
                                            <label className="styleTitle">Mobile App Developer</label>
                                        </div>
                                    </td>
                                </Col>
                                <Col md={8} sm={6}>
                                    <td>
                                        <ul>
                                            <li>
                                                พัฒนาแอปพลิเคชันฝั่งผู้ใช้ (Front-end application) บนอุปกรณ์เคลื่อนที่
                        <br />เช่น โทรศัพท์มือถือหรือ Tablet สำหรับโครงการธุรกิจที่ได้รับมอบหมาย
                        </li>
                                            <li>
                                                พัฒนาและทดสอบแอปพลิเคชันตาม business logic และ use case ที่ได้รับ
                        </li>
                                        </ul>
                                    </td>
                                </Col>
                            </tr>
                            <br />
                            <tr>
                                <Col md={4} sm={6}>
                                    <td>
                                        <label className="styleTitle" style={{ marginLeft: 20 }}>คุณสมบัติ</label>
                                    </td>
                                </Col>
                                <Col md={8} sm={6}>
                                    <td>
                                        <ul>
                                            <li>
                                                จบการศึกษา สาขาวิชาที่เกี่ยวข้อง
                        </li>
                                            <li>
                                                สามารถใช้ JavaScript รวมถึง ES6 (ES 2015) ได้เป็นอย่างดี
                        </li>
                                            <li>
                                                มีประสบการณ์ในการพัฒนาแอพที่ใช้ Framework
                        <br />สำหรับ Cross Platform Development ด้วย React Native
                        </li>
                                            <li>
                                                มีความเข้าใจหลักการทำงานที่สำคัญของ React อย่างเช่น Concept
                        <br />State Management หรือ Lifecycle ได้
                        </li>
                                            <li>
                                                มีความเข้าใจการเขียน UI ด้วย Flexbox ได้เป็นอย่างดี
                        </li>
                                            <li>
                                                มีความเข้าใจและคุ้นเคย Web Service, RESTFul API, GraphQL
                        </li>
                                            <li>
                                                สามารถใช้ Git ที่เป็น Version Control ในการทำงานร่วมกับคนอื่นๆ ในทีม
                        </li>
                                            <li>
                                                สามารถเรียนรู้เทคโนโลยีใหม่ได้อย่างรวดเร็ว กล้าแสดงความคิดเห็น
                        <br />และสามารถเรียนรู้ได้ด้วยตนเอง
                        </li>
                                            <li>
                                                มีความรับผิดชอบต่องานที่ได้รับมอบหมายและสามารถติดตามงานของตัวเอง
                        <br />ให้เสร็จลุล่วงตามกำหนดได้
                        </li>
                                        </ul>
                                    </td>
                                </Col>
                            </tr>
                            <StepCheckPriceContainer>
                                <Button style={{ marginBottom: 20 }} bsStyle="primary" className="check-button" onClick={() => window.location = `https://docs.google.com/forms/d/e/1FAIpQLSewVoQ8Gg6-aHN-y_GGPhOr3v0W6VO-z0rQuf6mMInoj142Lw/viewform`}>
                                    สมัครงาน
                </Button>
                                <hr />
                            </StepCheckPriceContainer>

                            <br />

                            {/* Software Automate Tester */}

                            <tr>
                                <Col md={4} sm={6}>
                                    <td>
                                        <div className="title">
                                            <label className="styleTitle">Software Automate Tester</label>
                                        </div>
                                    </td>
                                </Col>
                                <Col md={8} sm={6}>
                                    <td>
                                        <ul>
                                            <li>
                                                เป็นที่ปรึกษาให้ทีมในการออกแบบ Test Cases พร้อมทั้งวิเคราะห์ข้อ Concern ต่าง ๆ
                        </li>
                                            <li>
                                                หาสาเหตุที่แท้จริงของปัญหาที่เกี่ยวกับกระบวนการและขั้นตอนการทดสอบ Product
                        <br />และกำหนดเป็นมาตรฐานการทำงาน เพื่อทดสอบให้ Product มีคุณภาพ
                        </li>
                                            <li>
                                                ผลักดันให้ทีมสามารถเขียนและใช้งาน Automate Test ทั้ง Unit Test,
                        <br />Integration Test, System Test และเป็นที่ปรึกษาให้ทีมเขียน System Test
                        <br />ในกรณีที่ทีมต้องการความช่วยเหลือ
                        </li>
                                            <li>
                                                จัดทำ Test แบบ Manual ในส่วนที่จำเป็น
                        </li>
                                            <li>
                                                สุ่มตรวจสอบคุณภาพ ของ Product ที่เกิดจากการ Update ระบบงาน
                        <br />หรือ ทดสอบโดยสมมุติฐานเหตุการณ์การใช้งานจริง ที่ไม่ได้วางแผนมาก่อน (Exploratory Test)
                        </li>
                                            <li>
                                                มีส่วนร่วมในการตรวจสอบและแก้ไขปัญหาตรวจสอบปัญหาที่ได้รับแจ้ง
                        <br />รวมถึงข้อผิดพลาดส่วนอื่นๆที่อาจจะถูกกระทบ ในกรณีที่ลูกค้ามีปัญหาใช้งานไม่ได้
                        </li>
                                            <li>
                                                ให้ Feedback กับทีม เพื่อได้ลด Defect เดิมซ้ำๆและเกิดการพัฒนาอย่างต่อเนื่อง
                        </li>
                                        </ul>
                                    </td>
                                </Col>
                            </tr>
                            <br />
                            <tr>
                                <Col md={4} sm={6}>
                                    <td>
                                        <label className="styleTitle" style={{ marginLeft: 20 }}>คุณสมบัติ</label>
                                    </td>
                                </Col>
                                <Col md={8} sm={6}>
                                    <td>
                                        <ul>
                                            <li>
                                                มีพื้นฐานการใช้ ภาษา Python
                        </li>
                                            <li>
                                                มีความละเอียดรอบคอบ
                        </li>
                                            <li>
                                                มีประสบการณ์ในเขียน Test case
                        </li>
                                            <li>
                                                มีประสบการณ์ในการทำ Automate Testing Website และ Mobile application
                        <br />ด้วย Robot Framework และ Appium
                        </li>
                                            <li>
                                                สามารถเรียนรู้เทคโนโลยีใหม่ได้อย่างรวดเร็ว กล้าแสดงความคิดเห็น
                        <br />และสามารถเรียนรู้ได้ด้วยตนเอง
                        </li>
                                            <li>
                                                มีความรับผิดชอบต่องานที่ได้รับมอบหมายและสามารถติดตามงานของตัวเอง
                        <br />ให้เสร็จลุล่วงตามกำหนดได้
                        </li>
                                            <li>
                                                หากมีผลงานหรือตัวอย่างโปรเจคมาแสดงจะได้รับการพิจารณาเป็นพิเศษ
                        </li>
                                        </ul>
                                    </td>
                                </Col>
                            </tr>
                            <StepCheckPriceContainer>
                                <Button style={{ marginBottom: 20 }} bsStyle="primary" className="check-button" onClick={() => window.location = `https://docs.google.com/forms/d/e/1FAIpQLSewVoQ8Gg6-aHN-y_GGPhOr3v0W6VO-z0rQuf6mMInoj142Lw/viewform`}>
                                    สมัครงาน
                    </Button>
                                <hr />
                            </StepCheckPriceContainer>

                        </tbody>
                    </TablePosition>

                    <StepCheckPriceContainer data-aos="fade-up" data-aos-duration="1000">
                        <div>
                            <TextHeader
                                style={{ marginBottom: 40, marginTop: 30 }}
                                title="สวัสดิการ"
                            />
                        </div>

                        <Row>
                            <Col md={3} sm={6}>
                                <div>
                                    <div className="box-container">
                                        <div className="box">
                                            <div className="box-image"><i className="far fa-calendar-alt"></i></div>
                                            <div className="box-image-hover"><i className="far fa-calendar-alt"></i></div>
                                            <div className="box-title">ทำงาน <br />สัปดาห์ละ 5 วัน</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={3} sm={6}>
                                <div>
                                    <div className="box-container">
                                        <div className="box">
                                            <div className="box-image"><i class="far fa-clock"></i></div>
                                            <div className="box-image-hover"><i class="far fa-clock"></i></div>
                                            <div className="box-title">มีเวลา <br />การทำงานที่ยืดหยุ่น</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={3} sm={6}>
                                <div>
                                    <div className="box-container">
                                        <div className="box">
                                            <div className="box-image"><i class="far fa-ambulance"></i></div>
                                            <div className="box-image-hover"><i class="far fa-ambulance"></i></div>
                                            <div className="box-title">มีประกันอุบัติเหตุ</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={3} sm={6}>
                                <div>
                                    <div className="box-container">
                                        <div className="box">
                                            <div className="box-image"><i class="far fa-lightbulb"></i></div>
                                            <div className="box-image-hover"><i class="far fa-lightbulb"></i></div>
                                            <div className="box-title">มีค่าพัฒนา <br />และฝึกอบรมพนักงาน</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={3} sm={6}>
                                <div>
                                    <div className="box-container">
                                        <div className="box">
                                        <div className="box-image"><i class="far fa-piggy-bank"></i></div>
												<div className="box-image-hover"><i class="far fa-piggy-bank"></i></div>
												<div className="box-title">กองทุนสำรองเลี้ยงชีพ</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={3} sm={6}>
                                <div>
                                    <div className="box-container">
                                        <div className="box">
                                            <div className="box-image"><i class="far fa-bus"></i></div>
                                            <div className="box-image-hover"><i class="far fa-bus"></i></div>
                                            <div className="box-title">เที่ยวและงานเลี้ยง<br />ประจำปี</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={3} sm={6}>
                                <div>
                                    <div className="box-container">
                                        <div className="box">
                                            <div className="box-image"><i class="far fa-user"></i></div>
                                            <div className="box-image-hover"><i class="far fa-user"></i></div>
                                            <div className="box-title">มีชุดยูนิฟอร์ม</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>

                        </Row>
                    </StepCheckPriceContainer>
                </div>



                <DeviceContainer>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3876.5404450240753!2d100.60889471482976!3d13.685684990390254!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x311d672e8097f671%3A0x8b3d7495efdf67d5!2sGIZTIX+HQ!5e0!3m2!1sth!2sth!4v1562662978115!5m2!1sth!2sth"
                        style={{
                            width: "100%",
                            height: "300px",
                            border: 0,
                            marginBottom: -10
                        }}
                        allowfullscreen
                    />
                </DeviceContainer>

                <Footer />
            </Container>
        );
    }
}

export default withNamespaces()(GiztixBusiness);
